export default "__VITE_ASSET__DBVRaaVD__"